module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row justify-content-md-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": _vm.submitForm
    }
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(_vm.mode == 'edit') ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": "Opslaan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "type": "submit",
      "variant": "primary",
      "title": _vm.$t('tag.add')
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-save"
  })]) : _vm._e(), _vm._v(" "), _c('b-btn', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "variant": "outline-secondary",
      "title": "Terug",
      "exact": "",
      "to": {
        name: 'tagList'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1), _vm._v(" "), (_vm.mode == 'edit') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('tag.edit')))]) : _vm._e(), _vm._v(" "), (_vm.mode == 'add') ? _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('tag.add')))]) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('h2', [_vm._v(_vm._s(_vm.form.name ? _vm.form.name : 'Tag Naam'))]) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  }), _vm._v(" "), (!_vm.isFetching) ? _c('div', [(_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Naam:"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Onderdeel van:"
    }
  }, [_c('multiselect', {
    attrs: {
      "tag-placeholder": "Zoek bijbehorende tag",
      "placeholder": "Voeg een tag toe",
      "label": "name",
      "track-by": "name",
      "options": _vm.tags.filter(function (el) { return el.id != _vm.tag.id; }),
      "loading": _vm.isFetchingTags,
      "close-on-select": false,
      "multiple": true,
      "taggable": true
    },
    model: {
      value: (_vm.belongsToArray),
      callback: function($$v) {
        _vm.belongsToArray = $$v
      },
      expression: "belongsToArray"
    }
  })], 1)], 1)]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": "1",
      "unchecked-value": "0"
    },
    model: {
      value: (_vm.form.hidden),
      callback: function($$v) {
        _vm.$set(_vm.form, "hidden", $$v)
      },
      expression: "form.hidden"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t " + _vm._s(_vm.$t('tag.hiddenTag')) + "\n\t\t\t\t")])], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71e94ee3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Tag/TagForm.vue
// module id = 1328
// module chunks = 1